import React from "react"
import ReactDOM from "react-dom"
import { BrowserRouter } from "react-router-dom"
import PokemonContextProvider from "./contexts/singlePkmn"
import App from "./App"
import "./index.css"
import * as serviceWorker from "./serviceWorker"

ReactDOM.render(
  <React.StrictMode>
    <PokemonContextProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </PokemonContextProvider>
  </React.StrictMode>,
  document.getElementById("root")
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
